import { Paper, Typography } from "@mui/material";

import { ProductFeature } from "api/memberPortal/features/productFeatures/productFeatures.types";

interface TestedFeatureListItemProps {
  feature: ProductFeature;
}

const TestedFeatureReadOnlyItem = ({ feature }: TestedFeatureListItemProps) => {
  return (
    <Paper
      key={feature.id}
      elevation={1}
      sx={{
        p: 1.5,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        backgroundColor: "white",
      }}
    >
      <Typography variant="body2">{feature.feature_name}</Typography>
    </Paper>
  );
};

export default TestedFeatureReadOnlyItem;
